<template>
  <b-row>
    <b-col cols="6">
      <b-modal
        v-model="showModal"
        :ok-disabled="template == null"
        size="lg"
        title="Nieuwe prognose"
        ok-title="Template Gebruiken"
        ok-variant="success"
        @ok="createPrognose"
        @show="getTemplates"
      >
        <b-form-radio-group
          v-model="type"
          :options="['Templates', 'Complex', {text:'Transplan',disabled:true}]" 
          class="mb-2"
          @change="template=null"
        />

        <b-alert :show="type == 'Complex'">
          Onderstaand zijn alle prognoses van complex {{ unit.Complex.Relatie.Adviesnummer }}-{{ unit.Complex.ComplexNummer }}
          {{ unit.Complex.ComplexKenmerk }}
        </b-alert>

        <b-table
          :items="items"
          :fields="[
            'Omschrijving',
            { key: 'Datum', label: 'Inspectie datum' },
            { key: 'BijgewerktOp', label: 'Laatst bijgewerkt op' },
            'Inspecteur',
          ]"
          :empty-text="'Nog geen templates beschikbaar voor filter ' + type"
          bordered
          select-mode="single"
          selectable
          hover
          show-empty
          @row-selected="templateSelected"
        >
          <template 
            #cell(Omschrijving)="data" 
            align="center"
          >
            {{ data.item.unit.UnitKenmerk }}  <b-badge 
              v-if="data.item.p.IsTemplate" 
              variant="info" 
              class="mx-1"
            >
              Template
            </b-badge>

            <b-badge 
              v-if="data.item.p.Id == unit.HuidigePrognose" 
              variant="warning"
            >
              Start herinspectie
            </b-badge>
            <br>{{ data.item.p.Omschrijving || 'Geen omschrijving' }} <i 
              v-if="data.item.p.IsBevroren" 
              class="fa fa-lock"
            />
          </template>

          <template 
            #cell(Datum)="data" 
            align="center"
          >
            {{ data.item.p.Datum | formatDateTime("DD-MM-YYYY") }}
          </template>

          <template 
            #cell(BijgewerktOp)="data" 
            align="center"
          >
            {{
              data.item.p.BijgewerktOp | fromNow
            }}
          </template>

          <template 
            #cell(Inspecteur)="data" 
            align="center"
          >
            {{ data.item.p.Inspecteur }}
          </template>
        </b-table>
      </b-modal>
      
      <b-table
        :items="unit.Prognoses.slice().reverse()"
        :fields="[
          {key:'Selectie', label: ''},
          'Omschrijving',
          { key: 'Datum', label: 'Inspectie datum' },
          { key: 'BijgewerktOp', label: 'Laatst bijgewerkt op' },
          'Inspecteur',
        ]"
        bordered
        select-mode="single"
        selectable
        hover
        @row-selected="rowSelected"
      >
        <template #cell(Selectie)="data">
          <b-checkbox 
            v-if="data.item.Id !== unit.HuidigePrognose" 
            v-model="selected"
            :disabled="data.item.IsBevroren"
            :value="data.item.Id"
          />
        </template>

        <template 
          #cell(Omschrijving)="data" 
          align="center"
        >
          {{ data.item.Omschrijving || unit.UnitKenmerk }}
          <b-badge 
            v-if="data.item.New" 
            variant="success"
          >
            Nieuw!
          </b-badge>
          <b-badge 
            v-if="data.item.IsTemplate" 
            variant="info" 
            class="mx-1"
          >
            Template
          </b-badge>
          <b-badge 
            v-if="data.item.Id == unit.HuidigePrognose" 
            variant="warning"
          >
            Actueel
          </b-badge>
          
          <b-badge 
            v-if="data.item.Gereed" 
            class="mx-2"
            variant="info"
          >
            <font-awesome-icon icon="check" /> Inspectie voltooid
          </b-badge>
        </template>

        <template 
          #cell(Datum)="data" 
          align="center"
        >
          {{
            data.item.Datum | formatDateTime("DD-MM-YYYY")
          }}
        </template>

        <template 
          #cell(BijgewerktOp)="data" 
          align="center"
        >
          {{
            data.item.BijgewerktOp | fromNow
          }}
        </template>

        

        <template 
          #cell(Inspecteur)="data" 
          align="center"
        >
          {{
            data.item.Inspecteur
          }}
        </template>
      </b-table>
      <b-button-toolbar class="my-2">
        <b-button 
          variant="ghost" 
          @click="showModal = true"
        >
          <i class="fa fa-plus" /> Nieuwe prognose..
        </b-button>

        <b-button 
          v-if="selected.length > 0" 
          variant="ghost text-danger"
          small
          class="sm"
          @click="deletePrognoses"
        >
          <i class="fa fa-trash" /> Verwijderen {{ selected.length }} {{ selected.length === 1 ? 'prognose' : 'prognoses' }}
        </b-button>
      </b-button-toolbar>
    </b-col>
  </b-row>
</template>

<script>
import { prognoseMixin } from "@/mixins/prognoseMixin";
import { serviceMixin } from "@/mixins/serviceMixin";
import { voorbeeldPrognosesMixin } from "@/mixins/voorbeeldPrognosesMixin";
export default {
  mixins: [prognoseMixin, serviceMixin, voorbeeldPrognosesMixin],
  props: {
    unit: { type: Object },
    prognoseid: { type: String },
  },

  data() {
    return {
      templates: [],
      complextemplates: [],
      type: "Templates",
      showModal: false,
      template: null,
      selected: []
    };
  },
  computed: {
    items: function () {
      if (this.type == "Templates") return this.templates.slice().reverse().map(t => { return { p: t.prognose, template:t.inspectie, unit:t.unit } } );
      if (this.type == "Complex") return this.complextemplates.slice().reverse().map(t => { return { p: t.prognose, template:t.inspectie, unit:t.unit } } );
      return [];
    }

  },
  mounted() {
    this.getComplexTemplates()
  },
  methods: {
    rowSelected(record) {
      this.openPrognose(record[0].Id);
    },
    templateSelected(record) {
      this.template = record[0];
    },
    openPrognose(prognoseId) {
      // navigate to prognose
      this.$router.push({
        name: "Prognose",
        params: { prognoseid: prognoseId },
      });
    },
    createPrognose() {
      var vm = this;
      this.$http
        .post(
          "/unit/" + this.$props.unit.Id + "/inspecties",
          {
            inspectiedata: this.template.template,
            omschrijving: null,
          },
          
        )
        .then(function (response) {
          console.dir(response.data);
          var insp = response.data.inspectie;
          insp.New = true;
          vm.unit.Prognoses.push(insp);
          vm.$router.push({
            name: "Prognose",
            params: { prognoseid: insp.Id },
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deletePrognoses() {
      for (var i in this.selected) {
        var prognoseId = this.selected[i]
        console.log(prognoseId)
        console.log("/unit/" + this.$props.unit.Id + "/inspectie/" + prognoseId)
        this.deletePrognose(prognoseId);
      }
      this.selected = []
    },
    deletePrognose(id) {
      var vm = this
      this.delete("/unit/" + this.$props.unit.Id + "/inspectie/" + id)
        .then(function (response) {
          console.dir(response.data);
          for (var p in vm.unit.Prognoses) {
            if (vm.unit.Prognoses[p].Id == id) {
              vm.unit.Prognoses.splice(p, 1);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTemplates() {
      console.log(" templates ophalen...");
      var vm = this
      this.get("/inspectie/templates")
        .then(function (response) {
          vm.templates = response.data.inspecties;
          console.dir(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getComplexTemplates() {
      console.log(" templates ophalen...");
      var vm = this;
      var adviesnummer = this.unit && this.unit.Complex && this.unit.Complex.Relatie ? this.unit.Complex.Relatie.Adviesnummer : null;
      var complexnummer = this.unit && this.unit.Complex ? this.unit.Complex.ComplexNummer : null;
      if (!adviesnummer || !complexnummer) {
        console.warn("getComplexTemplates: complex zonder nummer, fetch overgeslagen", { unitId: this.unit ? this.unit.Id : null, adviesnummer: adviesnummer, complexnummer: complexnummer });
        return;
      }
      this.get(`/inspectie/templates/${adviesnummer}/${complexnummer}`)
        .then(function (response) {
          console.dir(response.data);
          vm.complextemplates = response.data.inspecties;
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>